export default "__VITE_ASSET__3e6765e7__"